// Initialize dataLayer if it doesn't exist
if (typeof window !== 'undefined' && !window.dataLayer) {
  window.dataLayer = [];
}

export function pushDataLayer (data) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    try {
      window.dataLayer.push(data);
    } catch (error) {
      console.error('[DataLayer] Error pushing data:', error);
    }
  }
}

function getLayout (windowWidth) {
  if (windowWidth < 768) {
    return 'mobile';
  }
  if (windowWidth < 1024) {
    return 'tablet';
  }
  return 'desktop';
}

export function generatePageLoadEvent ({ pagePath, user = null }) {
  const baseEvent = {
    event: 'pageLoad',
    environment: process.env.VUE_APP_ENVIRONMENT === 'production' ? 'prod' : 'preprod',
    siteType: 'vacances',
    pagePath: pagePath || (typeof window !== 'undefined' ? window.location.pathname : ''),
    pageType: 'Espace perso',
    siteVersion: 'speedboat',
    siteBrand: 'UCPA',
    siteName: 'ucpa.com',
    xHTTPCode: 200,
    layout: typeof window !== 'undefined' ? getLayout(window.innerWidth) : 'unknown'
  };

  if (user) {
    baseEvent.userLogged = user.uuid ? 'oui' : 'non';
    baseEvent.userSiteCustomerProfile = user.isCommonCustomer ? 'connu' : 'nouveau';
  }

  return baseEvent;
}

export function pushPageLoadEvent (options) {
  const event = generatePageLoadEvent(options);
  pushDataLayer(event);
}

// export function pushInteractionEvent ({ eventCommand, eventCategory, eventLabel, additionalData = {} }) {
//   const event = {
//     event: 'interaction',
//     eventCommand: eventCommand,
//     eventCategory: eventCategory || 'user-action',
//     pagePath: typeof window !== 'undefined' ? window.location.pathname : '',
//     ...additionalData
//   };

//   if (eventLabel) {
//     event.eventLabel = eventLabel;
//   }

//   pushDataLayer(event);
// }

// export function pushNavigationEvent ({ from, to, navigationType }) {
//   pushDataLayer({
//     event: 'navigation',
//     eventCommand: 'pageNavigation',
//     navigationType: navigationType || 'unknown',
//     fromPath: from,
//     toPath: to,
//     pagePath: typeof window !== 'undefined' ? window.location.pathname : ''
//   });
// }
